import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("gysumo_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Separate instance for customer (visitor) auth — uses its own token
export const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("gysumo_customer_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function mediaUrl(id, thumb = false) {
  if (!id) return null;
  return `${API}/media/${id}${thumb ? "/thumb" : ""}`;
}

function getVid() {
  let v = localStorage.getItem("gysumo_vid");
  if (!v) {
    v = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("gysumo_vid", v);
  }
  return v;
}

export function track(path, type = "page", ref = null) {
  try {
    const w = window.innerWidth;
    const device = w < 768 ? "mobile" : w < 1024 ? "tablet" : "desktop";
    api.post("/track", { path, type, ref, vid: getVid(), referrer: document.referrer || "", device }).catch(() => {});
  } catch (e) {
    /* ignore */
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
